import { useTranslations } from 'next-intl';
import { Checkbox } from '../../../../../packages/ui/components/checkbox';
import { FC, useState } from 'react';
import { useUpdateUserPublicity } from '@wwe-portal/web/providers/queries/rbe';
import { useIsAuthenticated } from '@wwe-portal/web/providers/stores/auth-store';

export const PublicUsernameCheckbox: FC<{
  isHidden: boolean;
  eventId: string;
  leaderboardId: string;
}> = ({ isHidden, eventId, leaderboardId }) => {
  const t = useTranslations();
  const isAuthenticated = useIsAuthenticated();
  const [checked, setChecked] = useState(!isHidden);
  const { mutate: updateUserPublicity } = useUpdateUserPublicity(eventId);
  const handleChange = (value: boolean) => {
    const previousValue = checked;
    setChecked(value);
    updateUserPublicity(
      {
        leaderboardId,
        isAnonymous: !value,
      },
      {
        onError: () => {
          setChecked(previousValue);
        },
      }
    );
  };

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="flex items-center gap-3">
      <Checkbox
        variant="green"
        checked={checked}
        onCheckedChange={handleChange}
        size="large"
      />
      <label className="text-textColor2 text-xs font-semibold">
        {checked
          ? t('rbe.showing_public_username')
          : t('rbe.show_public_username')}
      </label>
    </div>
  );
};
